import ReactGA from 'react-ga4';
import { getConfig } from './config';

const trackingId = getConfig().GOOGLE_ANALYTICS_TRACKING_ID;
try {
    ReactGA.initialize(trackingId, {
        gaOptions: {
            send_page_view: false // Prevent sending automatic pageview events
        }
    });
} catch (err) {
    console.log(err);
}
